import { useOrderApiClient } from '../OrderApi'
import { useQuery } from '@tanstack/react-query'

// Query for organisations caps from CRM, used to decide which organisations are
// listed in upsell
const useOrganisationCaps = (businessArea) => {
  const client = useOrderApiClient()

  return useQuery({
    queryKey: ['caps', businessArea],
    queryFn: () => {
      return client.fetchOrganisationCaps(businessArea)
    },
  })
}

export default useOrganisationCaps
